import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=f2b85048&scoped=true"
import script from "./Learning.vue?vue&type=script&lang=js"
export * from "./Learning.vue?vue&type=script&lang=js"
import style0 from "./Learning.vue?vue&type=style&index=0&id=f2b85048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b85048",
  null
  
)

export default component.exports